import { getErrorPayload } from '@application/helpers/api-helper';
import familyRelationsAPI from '@infrastructure/family-relations-api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { createFamilyRelationToFormData, updateFamilyRelationToFormData } from './models/family-relation-dto';
export const createFamilyRelationAsync = createAsyncThunk('familyRelations/create', async (request, { rejectWithValue }) => {
    try {
        const formData = createFamilyRelationToFormData(request);
        const response = await familyRelationsAPI.createFamilyRelation(formData);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateFamilyRelationAsync = createAsyncThunk('familyRelations/update', async (request, { rejectWithValue }) => {
    try {
        const formData = updateFamilyRelationToFormData(request);
        const response = await familyRelationsAPI.updateFamilyRelation(formData);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteFamilyRelationAsync = createAsyncThunk('familyRelations/delete', async (id, { rejectWithValue }) => {
    try {
        await familyRelationsAPI.deleteFamilyRelation(id);
        return id;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFamilyRelationByIdAsync = createAsyncThunk('familyRelations/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await familyRelationsAPI.getFamilyRelationById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFamilyRelationsByPersonIdAsync = createAsyncThunk('familyRelations/getByPersonId', async (personId, { rejectWithValue }) => {
    try {
        const response = await familyRelationsAPI.getFamilyRelationsByPersonId(personId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
